import { axiosRequest } from '@/plugins/axios-common'
import { buildURL } from '@/utilities'
import { handleError } from '@/store/handle-error'

export const AdvancedSearchJobsState = {
  backgroundJobs: [],
  loadingBackgroundJob: false,
}

export const AdvancedSearchJobsActions = {
  fetchBackgroundJobs: async ({ commit }) => {
    return axiosRequest.get('/advanced_search/background_jobs').
      then(({ data }) => commit('setAdvancedSearchJobs', data)).
      catch(handleError)
  },
  fetchBackgroundJob: async ({ commit, dispatch }, uuid) => {
    commit('setLoadingBackgroundJob', true)
    return axiosRequest.get(`/advanced_search/background_jobs/${uuid}`).
      then(({ data }) => dispatch('loadSearchTerms', data)).
      catch(handleError).
      finally(_ => {
        commit('setLoadingBackgroundJob', false)
      })
  },

  stopBackgroundJob: async ({ dispatch }, uuid) => {
    return axiosRequest.post(`/advanced_search/background_jobs/${uuid}/stop`).
      then(_ => dispatch('fetchBackgroundJobs')).
      catch(handleError)
  },

  updateBackgroundJob: async ({ dispatch }, { uuid, data }) => {
    return axiosRequest.patch(`/advanced_search/background_jobs/${uuid}`, { data: data }).
      then(_ => dispatch('fetchBackgroundJobs')).
      catch(handleError)
  },

  rerunBackgroundJob: async ({ dispatch }, uuid) => {
    return axiosRequest.post(`/advanced_search/background_jobs/${uuid}/rerun`).
      then(_ => dispatch('fetchBackgroundJobs')).
      catch(handleError)
  },

  deleteExpiredBackgroundJobs: async ({ dispatch }) => {
    return axiosRequest.delete('/advanced_search/background_jobs/expired').
      then(_ => dispatch('fetchBackgroundJobs')).
      catch(handleError)
  },

  deleteSelectedBackgroundJobs: async ({ dispatch }, jobs) => {
    const ids = jobs.map(j => j.id)
    return axiosRequest.delete(buildURL('/advanced_search/background_jobs/bulk', { ids })).
      then(_ => dispatch('fetchBackgroundJobs')).
      catch(handleError)
  },

  updateBackgroundJobStatus: async ({ commit, getters }) => {
    const jobs = getters.advancedSearchJobs

    return axiosRequest.get('/advanced_search/background_jobs').
      then(({ data }) => {
        commit('setAdvancedSearchJobs', jobs.map(j => {
          return {
            ...j,
            status: data.find(d => d.id === j.id)?.status,
          }
        }))
      }).
      catch(handleError)
  },
}

export const AdvancedSearchJobsGetters = {
  advancedSearchJobs: state => state.searchJobs.backgroundJobs,
  loadingBackgroundJob: state => state.searchJobs.loadingBackgroundJob,
  loadedJob: state => state.loadedJob,
}
export const AdvancedSearchJobsMutations = {
  setAdvancedSearchJobs: (state, jobs) => {
    state.searchJobs.backgroundJobs = jobs
  },
  setLoadingBackgroundJob: (state, loading) => {
    state.searchJobs.loadingBackgroundJob = loading
  },
}
